import { Badge, Form } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { APIURL } from "../../../../configApi";
import axios from "axios";
import { config } from "../../../../authentication/auth";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import WorkService from "../../../services/WorkService";

export default function (props) {
  const { checked, id, getCurrentWorkData, setChecked } = props;
  const [localCheck, setLocalCheck] = useState(checked);
  const [url, setUrl] = useState("");

  const CheckToggleUrgent = async () => {
    try {
      const response = await WorkService.toggleStatus(id, {
        is_urgent: !checked,
      });
      if (response.status === 200) {
        setChecked(!checked);
        getCurrentWorkData();
        NotificationManager.success(
          "Status urgent changé avec sucèes",
          "Notification"
        );
      }
    } catch (err) {
      NotificationManager.error(err?.response?.data?.message, "Notification");
    }
  };

  useEffect(() => {
    setLocalCheck(checked);
  }, [checked]);

  return (
    <div className="d-flex">
      <Form.Check
        type="switch"
        id="urgent_check"
        checked={localCheck}
        onChange={CheckToggleUrgent}
      />
      Urgent ?
    </div>
  );
}
